import { Component, HostListener, Input, OnInit } from '@angular/core';
import { TranslationHelper } from 'src/app/client/core/lib/translation.helper';
import { PopoverModel } from './popover.model';

@Component({
  selector: 'app-popover',
  templateUrl: './popover.component.html',
})
export class PopoverComponent extends TranslationHelper implements OnInit {
  @Input() popoverInfo?: PopoverModel;

  constructor() {
    super();
  }

  smallScreen = false;

  ngOnInit(): void {
    if (this.popoverInfo?.prefix) {
      this.setTranslationPrefix(this.popoverInfo?.prefix);
    }

    if (window.innerWidth <= 991) {
      this.smallScreen = true;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (event.target.innerWidth <= 991) {
      this.smallScreen = true;
    } else {
      this.smallScreen = false;
    }
  }

  getTrigger(): string {
    if (this.smallScreen) {
      return 'click';
    }
    return 'mouseenter:mouseleave';
  }
}
